module.exports = __webpack_public_path__ + "img/3_71.0109e69c.png";